import { toApiAcceptedDateFormat } from '../../../../shared/payload.utils';

export const TRANSACTION_TYPES = Object.freeze({
  1: 'DEPOSIT',
  2: 'WITHDRAWAL',
  3: 'TRANSFER',
  4: 'BONUS',
  5: 'P2P TRANSFER',
  7: 'COMMISSION',
  10: 'DEBIT',
  11: 'CREDIT',
  12: 'REVENUE SHARE',
  13: 'RESET BOOKIE PASSWORD',
});

class FilterForm {
  constructor() {
    this.search = null;
    this.dateFrom = null;
    this.dateTo = null;
    this.status = null;
    this.paymentOption = null;
    this.page = null;
    this.selectedTypes = null;

    this.types = [];
    this.statuses = [];
    this.paymentOptions = [];

    this.setTypes();
  }

  setTypes() {
    for (let key in TRANSACTION_TYPES) {
      this.types.push({
        value: key,
        text: TRANSACTION_TYPES[key]
      });
    }
  }

  setStatuses(statuses) {
    this.statuses = Object.keys(statuses).map(function(key) {
      return { value: key, text: statuses[key] };
    });

    // Add default
    this.statuses.unshift({
      value: '',
      text: 'All Status'
    });

    this.status = this.statuses[0].value;
  }

  setPaymentOptions(paymentOptions) {
    this.paymentOptions = Object.keys(paymentOptions).map((paymentOption) => {
      return {
        type: paymentOption,
        text: paymentOption
      };
    });

    // Add default
    this.paymentOptions.unshift({
      type: '',
      text: 'All Payment Options'
    });

    this.paymentOption = this.paymentOptions[0].type;
  }

  toPayload() {
    return {
      search: this.search,
      from: toApiAcceptedDateFormat(this.dateFrom),
      to: toApiAcceptedDateFormat(this.dateTo),
      types: this.selectedTypes,
      paymentOption: this.paymentOption,
      status: this.status,
      page: this.page,
    };
  }

  reset() {
    this.search = null;
    this.dateFrom = null;
    this.dateTo = null;
    this.page = null;
    this.selectedTypes = null;
    this.paymentOption = '';
    this.page = null;
    this.status = '';
  }
};

export default FilterForm;



// WEBPACK FOOTER //
// ./client/app/pages/customer/overview/model/form.model.js